// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import Viewer from "react-viewer";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'visible' implicitly has an 'any' type.
function ImageViewer({ visible, images, zoomSpeed = 0.5, onClose }) {
  return <Viewer visible={visible} images={images} zoomSpeed={zoomSpeed} onClose={onClose} />;
}

export { ImageViewer };
